import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import type { HasilDarahKonteks } from "@/types/hasil_pemeriksaan_darah";

async function katalog() {
  const response = await http
    .getData("/hasil-pemeriksaan-darah/katalog")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/hasil-pemeriksaan-darah`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function index(params: {
  tanggal_dari?: string;
  tanggal_sampai?: string;
  term?: string;
}) {
  const response = await http
    .getDataParam("/hasil-pemeriksaan-darah", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/hasil-pemeriksaan-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/hasil-pemeriksaan-darah", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/hasil-pemeriksaan-darah/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/hasil-pemeriksaan-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPetugas(id: number, data: { password: string }) {
  const response = await http
    .putData(`/hasil-pemeriksaan-darah/${id}/sign-petugas`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function konteks(register_id: string | number): Promise<HasilDarahKonteks> {
  const response = await http
    .getData(`/register/${register_id}/hasil-pemeriksaan-darah/konteks`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data.data;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/hasil-pemeriksaan-darah/${id}/pdf`, "_blank");
}

export default {
  katalog,
  getByRegister,
  index,
  find,
  create,
  update,
  destroy,
  signPetugas,
  konteks,
  printPdf
};
